import { addMinutes } from 'date-fns';

export const sessionExpired = (session, minutes) => {
  const sessionDate = new Date(parseInt(session));
  const expirationDate = addMinutes(sessionDate, minutes);
  return session === null || expirationDate < new Date();
};
